import { AppRoutes } from "@/routes/config";
import { TBaseSessionState, useListSessionStorage } from "@/hooks/useListSessionStorage";

const CONTACT_TYPE_LIST_SESSION_KEY = "contact_type_list_state";

export type TContactTypeListSessionState = TBaseSessionState;

export const useContactTypeListSessionStorage = () => {
  return useListSessionStorage<TContactTypeListSessionState>({
    sessionKey: CONTACT_TYPE_LIST_SESSION_KEY,
    defaultBackUrl: AppRoutes.contactType,
  });
};
